var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c0dwtkci2a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 11",
    style: {
      fill: "#fff"
    },
    d: "M0 0h22.666v18.125H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4",
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8",
    style: {
      clipPath: "url(#c0dwtkci2a)"
    },
    transform: "translate(6.667 8.938)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M18.583 13.75a.5.5 0 0 1-.5-.5v-5.5a6.75 6.75 0 1 0-13.5 0v5.5a.5.5 0 0 1-1 0v-5.5a7.75 7.75 0 0 1 15.5 0v5.5a.5.5 0 0 1-.5.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13",
    d: "M18.749 13.75a.5.5 0 0 1 0-1 2.8 2.8 0 0 0 2.917-2.666 2.8 2.8 0 0 0-2.917-2.668.5.5 0 0 1 0-1 3.8 3.8 0 0 1 3.917 3.668 3.8 3.8 0 0 1-3.917 3.666",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14",
    d: "M3.917 13.75A3.8 3.8 0 0 1 0 10.084a3.8 3.8 0 0 1 3.917-3.668.5.5 0 0 1 0 1A2.8 2.8 0 0 0 1 10.084a2.8 2.8 0 0 0 2.917 2.666.5.5 0 0 1 0 1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15",
    d: "M15.04 17.1a.5.5 0 0 1-.038-1c3.075-.241 3.081-2.445 3.081-2.539a.5.5 0 0 1 .493-.506h.007a.5.5 0 0 1 .5.493c0 .032 0 3.237-4 3.548h-.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16",
    d: "M13.843 15.938a.594.594 0 1 1-.594.593.595.595 0 0 1 .594-.593m0-1a1.594 1.594 0 1 0 1.594 1.593 1.594 1.594 0 0 0-1.594-1.593",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrm);
export default __webpack_public_path__ + "static/media/crm.ba893f3bb0292fd52749bb8bf36da68e.svg";
export { ForwardRef as ReactComponent };